export default "__VITE_ASSET__BhYxUbJt__"